import React, { useState } from "react";
import { useUI } from "../../context/UIContext";
import { deleteServer } from "../../api";

export default function DeleteServerModal({ code, name, onDeleted }) {
  const { toast, closeModal } = useUI();
  const [confirm, setConfirm] = useState("");

  const doDelete = async () => {
    if (confirm.trim() !== code) return toast(`Gõ đúng: ${code}`, "err");
    try {
      const { ok, data } = await deleteServer(code);
      if (!ok) return toast(data.message || "Lỗi xoá", "err");
      closeModal();
      onDeleted(code);
      toast(`Đã xoá ${code}`, "warn");
    } catch (err) {
      toast("Không kết nối được BackendNode", "err");
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <div style={{
        background: "var(--red-soft)",
        border: "1px solid var(--red)",
        borderRadius: "10px",
        padding: "12px 14px",
        color: "var(--red)",
        fontSize: "13px",
        lineHeight: "1.5",
      }}>
        ⛔ Xoá <strong>{name}</strong> sẽ xoá toàn bộ log và cấu hình liên quan. Hành động này <strong>không thể hoàn tác</strong>.
      </div>
      
      <div className="field-lbl">
        Gõ ServerCode để xác nhận:{" "}
        <strong style={{ color: "var(--red)" }}>{code}</strong>
      </div>
      <input
        className="field-inp"
        type="text"
        value={confirm}
        placeholder={code}
        onChange={(e) => setConfirm(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && doDelete()}
      />
      
      <div className="modal-footer" style={{ marginTop: "15px" }}>
        <button className="mbtn mbtn-cancel" onClick={closeModal}>
          Huỷ
        </button>
        <button className="mbtn mbtn-danger" onClick={doDelete}>
          ✕ Xoá vĩnh viễn
        </button>
      </div>
    </div>
  );
}
